"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReviewRequestsTableGenerator = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _config = _interopRequireDefault(require("./config"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Generate a Review Requests Table with the custom configuration
 * applied
 *
 * @param {object} [uiConfig]
 * @returns {object} { SearchBox }
 */
var ReviewRequestsTableGenerator = function ReviewRequestsTableGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var functions = uiConfig.functions;
  var CustomDataTable = functions && functions.CustomDataTable ? functions.CustomDataTable : _config.default.functions.CustomDataTable;
  var ReviewRequestsTable = function ReviewRequestsTable(_ref) {
    var classes = _ref.classes,
      columns = _ref.columns,
      data = _ref.data,
      options = _ref.options;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(CustomDataTable, {
      data: data,
      columns: columns,
      options: options,
      className: classes.customDataTable
    }))));
  };
  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    ReviewRequestsTable: (0, _core.withStyles)(_styles.default, {
      withTheme: true
    })(ReviewRequestsTable)
  };
};
exports.ReviewRequestsTableGenerator = ReviewRequestsTableGenerator;
var _default = ReviewRequestsTableGenerator;
exports.default = _default;